<template>
<transition appear name="fade">
  <div v-show="scY" class="work-slide-wrapper">
    <div class="work-slide-left"><font-awesome-icon icon="angle-left" class="fa-1x"/></div>
  </div>
</transition>
</template>

<script>
import { WorkScroll } from '@/WorkScroll';
export default {
  mixins: [ WorkScroll ]
}

</script>

<style lang="scss" scoped>
.work-slide-wrapper {
  position: relative;
}

.work-slide-left {
  position: fixed;
  top: 50%;
}

.work-slide-left:hover {
  cursor: pointer;
}

.work-slide-left {
  left: 2%;
}
</style>